import { ECOMemberPassIntegrationMutations } from './partials/eco-member-pass'
import { ECOPortalIntegrationMutations } from './partials/eco-portal'
import { OWRIntegrationMutations } from './partials/owr'
import { SignupIntegrationMutations } from './partials/signup'
import { TmetricMutations } from './partials/tmetric'

export const IntegrationMutations = {
  ...ECOMemberPassIntegrationMutations,
  ...ECOPortalIntegrationMutations,
  ...OWRIntegrationMutations,
  ...SignupIntegrationMutations,
  ...TmetricMutations,
}
